var _circle, _mask, _g, _mask2, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconChatWhiteFilled = function SvgIconChatWhiteFilled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 5,
    width: 17,
    height: 14
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.89453 5H19.9998V19H3.89453V5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8675 10.7437H16.6003V6.38446C16.6003 5.61993 15.9437 5 15.1335 5H5.36143C4.55137 5 3.89453 5.61993 3.89453 6.38446V13.0468C3.89453 13.8114 4.55137 14.4311 5.3612 14.4311H6.1929V15.9951C6.17037 16.3378 6.32404 16.6171 6.60529 16.7455C6.70342 16.7897 6.80803 16.8121 6.91508 16.8121C7.12719 16.8121 7.34822 16.7253 7.54003 16.5559L9.76457 14.4311H14.4969V13.6145H9.58436C9.4686 13.6145 9.35753 13.6585 9.27635 13.7362L7.05805 15.8557V14.0229C7.05805 13.7975 6.86446 13.6145 6.62514 13.6145H5.36098C5.02866 13.6145 4.75946 13.3605 4.75946 13.0468V6.38446C4.75946 6.07208 5.03044 5.81632 5.36143 5.81632H15.1335C15.466 5.81632 15.7354 6.07082 15.7354 6.38446V10.7437H15.7336V11.5601H15.7354H16.6003H18.8675C19.0151 11.5601 19.1349 11.6731 19.1349 11.8124V16.3199C19.1349 16.4593 19.0151 16.5721 18.8677 16.5721H18.1219C17.883 16.5721 17.6894 16.7548 17.6894 16.9802V18.0662L15.3775 16.6386C15.307 16.5952 15.2247 16.5721 15.1406 16.5721H12.2559C12.1087 16.5721 11.9884 16.4584 11.9884 16.3197V15.8976C11.9884 15.6722 11.7949 15.4893 11.556 15.4893C11.3169 15.4893 11.1233 15.6722 11.1233 15.8976V16.3199C11.1233 16.9101 11.6305 17.3886 12.2556 17.3886H15.0119L17.3671 18.8434C17.5393 18.9472 17.7198 19.0002 17.889 19C18.0151 19 18.1344 18.971 18.2396 18.9116C18.4526 18.7916 18.5693 18.5683 18.5544 18.311V17.3886H18.8675C19.4931 17.3886 19.9998 16.9099 19.9998 16.3197V11.8122C19.9998 11.2228 19.492 10.7437 18.8675 10.7437Z",
    fill: "#767778"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 5,
    width: 17,
    height: 14
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 19H19.1053V5H3V19Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.53831 11.605H10.3085V10.9499H9.53831V11.605ZM11.3391 8.77924C11.3391 8.89186 11.3199 8.99438 11.282 9.08637C11.2441 9.17856 11.1908 9.26655 11.1219 9.35012C11.0534 9.43369 10.9693 9.51558 10.8698 9.59578C10.7704 9.67598 10.6591 9.76207 10.5362 9.85448C10.482 9.89174 10.4378 9.92669 10.4035 9.95931C10.3689 9.99173 10.341 10.025 10.3194 10.0591C10.2975 10.0932 10.2824 10.1317 10.2732 10.1742C10.2643 10.217 10.2596 10.269 10.2596 10.3302V10.5813H9.59786V10.2279C9.59786 10.1631 9.60255 10.1077 9.61147 10.0616C9.62061 10.0155 9.63957 9.96942 9.66857 9.92353C9.69734 9.87743 9.73882 9.82796 9.79302 9.77512C9.84744 9.72208 9.9197 9.6564 10.0103 9.57789C10.097 9.50295 10.1711 9.43453 10.2326 9.37307C10.294 9.3116 10.3446 9.25287 10.3845 9.19667C10.424 9.14025 10.453 9.08468 10.471 9.02995C10.4891 8.97564 10.4983 8.91733 10.4983 8.85608C10.4983 8.76725 10.4784 8.69147 10.4387 8.62832C10.3988 8.56516 10.3446 8.51296 10.2759 8.47212C10.2072 8.43129 10.126 8.40055 10.0319 8.38013C9.93777 8.35951 9.8383 8.34919 9.73369 8.34919C9.63578 8.34919 9.5401 8.35614 9.4462 8.36982C9.35208 8.38329 9.25796 8.40392 9.16406 8.43129V7.89872C9.29052 7.8783 9.41721 7.86125 9.54367 7.84757C9.67035 7.83409 9.79681 7.82715 9.92327 7.82715C10.0932 7.82715 10.2632 7.84167 10.4331 7.87072C10.6031 7.89977 10.755 7.95008 10.8888 8.02165C11.0226 8.09343 11.131 8.19068 11.2142 8.31341C11.2974 8.43634 11.3391 8.59148 11.3391 8.77924Z",
    fill: "#767778"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconChatWhiteFilled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-chat-white-filled.8c33a081.svg";
export { ForwardRef as ReactComponent };